import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import { create } from 'zustand';

export type MasterclassDetails = {
  masterclassDetails: IMasterclassDescription;
  setMasterclassDetails: (data: IMasterclassDescription) => void;
  isMasterclassBought: boolean;
  setIsMasterclassBought: (data: boolean) => void;
  loading: boolean;
  setIsLoading: (data: boolean) => void;
  resetMasterclassDetails: () => void;
};

const initialState = {
  _id: '',
  about: {
    descriptionSections: [],
    coursePointers: [],
  },
  pricing: {
    pricingOnCardHero: '',
    ctaOnCard: '',
    IN: 0,
    US: 0,
    isFree: false,
    discount: 0,
  },
  mobilePricing: {
    pricingOnCardHero: '',
    ctaOnCard: '',
  },
  coursePurchaseType: '',
  makeActiveForPurchase: false,
  isProgramFeatured: false,
  enableAboutCourse: false,
  courseType: '',
  onlineDegreeType: '',
  isJobGuaranteeProgram: false,
  isJobAssistanceProgram: false,
  categoryIncludingParents: [],
  active: false,
  platformType: '',
  tags: [],
  labPlans: [],
  programType: [],
  levels: [],
  showOnHomePage: false,
  npfTrackingEnable: false,
  checkoutFlowType: '',
  pageTheme: '',
  slug: '',
  canonicalTag: '',
  registration: {
    startDate: '',
    endDate: '',
  },
  seo: {
    title: '',
    description: '',
    keywords: '',
    ogTitle: '',
    twitterTitle: '',
    ogDescription: '',
    twitterDescription: '',
    ogImage: '',
    twitterImage: '',
  },
  faq: [
    {
      _id: '',
      question: '',
      answer: '',
    },
  ],
  title: '',
  description: '',
  batches: [],
  masterclassTimings: {
    showStartDateOnCard: false,
    startTime: '',
    endTime: '',
  },
  liveVideoLink: '',
  masterclassId: '',
  heroSectionMeta: {
    companyLogo: [],
    _id: '',
    title: '',
    image: '',
    description: '',
    bgImage: '',
  },
  masterclassKeyFactors: [
    {
      _id: '',
      image: '',
      title: '',
      description: '',
    },
  ],
  glimpseOfMasterClass: [
    {
      _id: '',
      title: '',
      pointers: '',
    },
  ],
  whoShouldEnroll: [
    {
      _id: '',
      image: '',
      title: '',
      description: '',
    },
  ],
  certificateType: [],
  whatYouWillLearn: [
    {
      pointers: [],
      title: '',
      _id: '',
    },
  ],
  qrCodeImg: '',
  communityLink: '',
  img: '',
};

const useMasterclassDescriptionStore = create<MasterclassDetails>((set) => ({
  masterclassDetails: initialState,
  setMasterclassDetails: (data) => {
    set(() => ({
      masterclassDetails: {
        ...data,
      },
    }));
  },
  isMasterclassBought: false,
  setIsMasterclassBought: (data) => {
    set(() => ({
      isMasterclassBought: data,
    }));
  },
  loading: false,
  setIsLoading: (data) => {
    set(() => ({
      loading: data,
    }));
  },
  resetMasterclassDetails: () => {
    set(() => ({
      masterclassDetails: { ...initialState },
    }));
  },
}));

export default useMasterclassDescriptionStore;
